//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'login',
    data() {
        return {
            formData: {
                account: '',
                pwd: '',
                vcode: '' //验证码（可选）
            }
        };
    },
    methods: {
        async login() {
            var res = await this.$x.post('login/login', this.formData)
            this.$x.userInfo.setUserInfo(res)
            this.$x.userInfo.save()
            this.$router.replace('/');
        }
    },
    components: {}
}
